import {PassedInitialConfig} from 'angular-auth-oidc-client';

// Determine clientId based on hostname, localhost and *-dev use iwofurn-dev, production uses iwofurn
const hostname = window.location.hostname;
const clientId = (hostname === 'localhost' || hostname.includes('-dev')) ? 'iwofurn-dev' : 'iwofurn';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: 'https://auth.fsn.supplycanvas.com',
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    clientId,
    scope: 'openid email profile groups',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    secureRoutes: ['/api/', '/ui/'],
    autoUserInfo: true,
    // Disable automatic redirect to unauthorized route - we handle auth in guards
    triggerAuthorizationResultEvent: false,
    unauthorizedRoute: '/',
    forbiddenRoute: '/',
  }
};
